const getClassPrefixer = rawPrefix => {
  const prefix = rawPrefix.replace(/\W+/g, '')
  return new Proxy({}, {
    get: (target, prop) => {
      if (typeof prop !== 'string') {
        return ''
      }
      target[prop] ??= `${prefix}-${prop}`
      return target[prop]
    }
  })
}

export default getClassPrefixer
